"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsButtonContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
exports.UsButtonContainer = styled_1.default.button `
    
    min-width: 100px;
    width: 100%;
    font-family: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$bold"]};
    border: none;
    cursor: pointer;
    padding: 10px 30px;

    &.lightBlue {
        &:disabled {
            opacity: 0.3;
        }
    }

    &.unicoBackground {
        color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
        transition: 0.2s;

        &.rosso {
            background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_red"]};

            &:hover {
                background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_red"]};
            }
        }

        &.rosso-disabled-grey {
            background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_red"]};

            &:disabled {
                color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$grey"]};
                background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$ivory"]};
                opacity: 1 !important;
            }
        }

        &.azzurro-ar {
            background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$light_blue"]};

            &:hover {
                background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$light_blue"]};
            }
        }

        &.azzurro-ar-cta {
            background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$medium-light-blue"]};

            &:hover {
                background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$medium-light-blue"]};
            }
        }

        &.blu-unipol {
            background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};

            &:hover {
                background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
            }
        }

        &:disabled {
            opacity: 0.3;
            cursor: not-allowed;
        }
    }

    &.borderBottom {
        background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
        color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
        border: 1px solid ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$grey"]};
        border-bottom: 4px solid ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_red"]};

        &:hover {
            border-bottom-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_red_hover"]};
        }
    }

    &.flat {
        background-color: transparent;
        color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
        border: none;
    }

    &.text-underline,
    &.text-no-underline {
        background-color: transparent;
        padding: 0px !important; // deve sovrascrivere quello di default
        border: none;
        color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
        font-size: 16px;
        text-decoration: underline;

        &.text-underline {
            text-decoration: underline;
        }
    }
`;
